import useSWRImmutable from 'swr/immutable';

import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { CompanyProfileService } from 'services/CompanyProfileService';
import { UserService } from 'services/UserService';

type ProfileUpgrade = {
    url: string;
    companyName: string;
};

const useProfileUpgrade = (): { upgrade: ProfileUpgrade | null; isLoading: boolean } => {
    const swr = useSWRImmutable<ProfileUpgrade | null>('/profile-upgrade', async () => {
        const user = await UserService.getCurrentUser();

        if (!user?.team) return null;

        const { docs } = await CompanyProfileService.getByTeam(user.team, 0);

        const profile = docs?.[0];

        if (!profile) return null;

        return {
            url: `${CompanyHelpers.urls.view(profile.slug)}?action=upgrade`,
            companyName: profile.name,
        };
    });

    return {
        upgrade: swr.data ?? null,
        isLoading: swr.isLoading,
    };
};

export { useProfileUpgrade };
export type { ProfileUpgrade };
